import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/usr/src/app/client/layouts/default.vue").then(m => m.default || m))
}